
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisHeadinglineTurnIec as ObiAisHeadinglineTurnIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-headingline-turn-iec.js';
 
 
 

 
 export const ObiAisHeadinglineTurnIec = createComponent({
   react: React,
   tagName: 'obi-ais-headingline-turn-iec',
   elementClass: ObiAisHeadinglineTurnIecElement,
   events: {
     
   }
  });
 
 